/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `CardFormat*`'s.
 */
export type CardFormat = CardFormatStandard | CardFormatButton;

/**
 * The Card standard format type.
 */
export type CardFormatStandard = typeof CARD_FORMAT_STANDARD;

/**
 * The Card button format type.
 */
export type CardFormatButton = typeof CARD_FORMAT_BUTTON;

/**
 * The Card standard format constant.
 */
export const CARD_FORMAT_STANDARD = `standard`;

/**
 * The Card button format constant.
 */
export const CARD_FORMAT_BUTTON = `button`;
